import PropTypes from "prop-types";

import {
  MONTH_DATE_YEAR_FORMAT,
  format,
  unixToDateTime,
  convertTimestampToDate,
} from "utils/date";
import { numberSeparator, roundOff } from "utils";

const getValueText = (p) => {
  const value = p.value;
  const percentage = p.payload?.perValue
    ? roundOff(value)
    : roundOff(value * 100);
  const beforeDecimalVal = String(value).split(".")[0];
  const { dollarValue, plainValue, tooltipValueText } = p.payload;

  if (tooltipValueText) return <span>{tooltipValueText}</span>;
  if (dollarValue) return <span>${numberSeparator(value)}</span>;
  if (!plainValue && value % 1 !== 0 && beforeDecimalVal.length < 4) {
    return <span>{numberSeparator(percentage)}%</span>;
  }
  return <span>{numberSeparator(value)}</span>;
};

const getLabelText = (p, i) => {
  if (p?.payload?.label2 && i === 1) return p.payload.label2;
  if (p?.payload?.label) return p.payload.label;
  if (p?.name === "value") return "";
  return p.name;
};

// Format the date header — period-aware when activePeriod is provided, else legacy behavior
const formatDate = (nameValue, activePeriod) => {
  if (!nameValue) return null;

  if (activePeriod) {
    return convertTimestampToDate(nameValue, activePeriod);
  }

  return (
    unixToDateTime(nameValue) ||
    (!isNaN(new Date(nameValue))
      ? format(MONTH_DATE_YEAR_FORMAT, new Date(nameValue))
      : nameValue)
  );
};

// Shared chart tooltip — pass `children` to customize rows, otherwise uses default rendering.
export const ChartTooltip = ({
  active = false,
  payload = [],
  activePeriod,
  children,
}) => {
  if (!active || !payload?.length) return null;

  const first = payload[0].payload;
  const dateStr = first.hideTimestamp
    ? null
    : formatDate(first.name, activePeriod);

  return (
    <div className="chart-tooltip">
      {dateStr && <span className="datetime">{dateStr}</span>}
      {children ??
        payload.map((p, i) => (
          <div key={i} className="label">
            <span>{getLabelText(p, i)} </span>
            <span>{getValueText(p)}</span>
          </div>
        ))}
    </div>
  );
};

ChartTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
  activePeriod: PropTypes.string,
  children: PropTypes.node,
};

ChartTooltip.displayName = "ChartTooltip";
